import Vue from "vue"
import Affix from "vue-affix"
import VueUiTable from "./vue-ui-table"
import hljs from "highlight.js"
import VueHighlightJS from "vue-highlightjs"
import router from "./docs/router"
import Docs from "./docs/docs"
import "./assets/scss/docs.scss"

Vue.use(Affix)
Vue.use(VueUiTable)

hljs.configure({ tabReplace: "  " })
Vue.use(VueHighlightJS)

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(Docs)
}).$mount("#app")